import { render } from "./addFAQ.vue?vue&type=template&id=7b1a385a"
import script from "./addFAQ.vue?vue&type=script&lang=js"
export * from "./addFAQ.vue?vue&type=script&lang=js"

import "./addFAQ.vue?vue&type=style&index=0&id=7b1a385a&lang=less"
script.render = render

export default script